//@flow
import React from 'react';
import {Link} from 'react-router-dom';

import {colors} from '../../../../assets/styles/colors';
import {Grid, Typography, makeStyles} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {TIENDADA_LINKS} from '../../../../constants';
import {HelpTwoTone, Add} from '@material-ui/icons';
import CrmCampaignTable from './crm-campaign-table';
import {useIsFeatureInTier} from '../../../../utils/component';
import UpgradeIcon from '../../../../elements/icons/UpgradeIcon';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
  },

  headerWrapper: {
    padding: '1rem',
  },
  ayudaButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    margin: '0 14px 0 0',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      fontSize: '12px',
      margin: '0 16px 0 0',
      padding: 0,
      boxShadow: 'unset',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },

  upgradeButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '.5rem auto',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    '&:hover': {
      backgroundColor: colors.grey200,
    },
  },
  upgradeButtonLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',

    '&[data-disabled="true"]': {
      pointerEvents: 'none',
      opacity: 0.5,
    },
  },
}));

export default function CrmCampaignSummary() {
  const classes = useStyles();

  const tiendachatFeature = useIsFeatureInTier('CRM_SEGMENT');

  return (
    <div className={classes.root}>
      <div className={classes.headerWrapper}>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <Typography className={classes.title}>Campañas</Typography>
          </Grid>
          <Grid item>
            <CustomButton
              href={TIENDADA_LINKS.customerSupport.general}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.ayudaButton}
              startIcon={<HelpTwoTone />}
            >
              Ayuda
            </CustomButton>
            <CustomButton
              variant="contained"
              startIcon={<Add />}
              component={Link}
              disabled={!tiendachatFeature}
              to="/campaigns/new"
            >
              Crear Campaña
            </CustomButton>
          </Grid>
        </Grid>
      </div>

      {!tiendachatFeature && (
        <CustomButton className={classes.upgradeButton} to="/tiers-list">
          <div className={classes.whiteButtonLabel}>
            <span>Mejora tu plan para acceder a esta funcionalidad</span>
            <UpgradeIcon width={18} height={18} />
          </div>
        </CustomButton>
      )}

      <div className={classes.container} data-disabled={!tiendachatFeature}>
        <CrmCampaignTable />
      </div>
    </div>
  );
}
